import { EBankCode } from '../../schema/types';

export const bankOptions: { value: EBankCode; label: string }[] = [
  { value: 'KYONGNAMBANK', label: '경남은행' },
  { value: 'GWANGJUBANK', label: '광주은행' },
  { value: 'KOOKMIN', label: 'KB국민은행' },
  { value: 'IBK', label: 'IBK기업은행' },
  { value: 'NONGHYEOP', label: 'NH농협은행' },
  { value: 'LOCALNONGHYEOP', label: '단위농협' },
  { value: 'DAEGUBANK', label: 'DGB대구은행' },
  { value: 'BUSANBANK', label: '부산은행' },
  { value: 'KDBBANK', label: 'KDB산업은행' },
  { value: 'SAEMAUL', label: '새마을금고' },
  { value: 'SANLIM', label: '산림조합' },
  { value: 'SUHYEOP', label: 'Sh수협은행' },
  { value: 'SHINHAN', label: '신한은행' },
  { value: 'SHINHYEOP', label: '신협' },
  { value: 'CITI', label: '씨티은행' },
  { value: 'WOORI', label: '우리은행' },
  { value: 'POST', label: '우체국예금보험' },
  { value: 'SAVINGBANK', label: '저축은행중앙회' },
  { value: 'JEONBUKBANK', label: '전북은행' },
  { value: 'JEJUBANK', label: '제주은행' },
  { value: 'KAKAOBANK', label: '카카오뱅크' },
  { value: 'KBANK', label: '케이뱅크' },
  { value: 'TOSSBANK', label: '토스뱅크' },
  { value: 'HANA', label: '하나은행' },
  { value: 'SC', label: 'SC제일은행' },
  { value: 'HSBC', label: '홍콩상하이은행' },
];

export const bankLabels: Record<EBankCode, string> = bankOptions.reduce(
  (acc, cur) => ({ ...acc, [cur.value]: cur.label }),
  {} as Record<EBankCode, string>
);

export const ALLOW_UPLOAD_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/webp',
  'image/gif',
];

export const ALLOW_UPLOAD_VIDEO_MIME_TYPES = [
  'video/x-msvideo',
  'video/mp4',
  'video/mpeg',
];

export const DELIVERY_COMPANY_OPTIONS = [
  { value: '01', label: '우체국' },
  { value: '04', label: 'CJ대한통운' },
  { value: '05', label: '한진택배' },
  { value: '06', label: '로젠택배' },
  { value: '08', label: '롯데택배' },
  { value: '11', label: '일양로지스' },
  { value: '12', label: 'EMS' },
  { value: '13', label: 'DHL' },
  { value: '14', label: 'UPS' },
  { value: '16', label: '한의사랑택배' },
  { value: '17', label: '천일택배' },
  { value: '18', label: '건영택배' },
  { value: '19', label: '고려택배' },
  { value: '20', label: '한덱스' },
  { value: '21', label: 'Fedex' },
  { value: '22', label: '대신택배' },
  { value: '23', label: '경동택배' },
  { value: '24', label: 'CVSnet 편의점 택배' },
  { value: '25', label: 'TNT Express' },
  { value: '26', label: 'USPS' },
  { value: '27', label: 'TPL' },
  { value: '28', label: 'GSMNtoN' },
  { value: '29', label: '에어보이익스프레스' },
  { value: '30', label: 'KGL네트웍스' },
  { value: '32', label: '합동택배' },
  { value: '33', label: 'DHL Global Mail' },
  { value: '34', label: 'i-Parcel' },
  { value: '35', label: '포시즌 익스프레스' },
  { value: '37', label: '범한판토스' },
  { value: '38', label: 'APEX' },
  { value: '40', label: '굿투럭' },
  { value: '41', label: 'GSI Express' },
  { value: '42', label: 'CJ대한통운 국제특송' },
  { value: '43', label: '애니트랙' },
  { value: '44', label: 'SLX' },
  { value: '45', label: '호남택배' },
  { value: '46', label: 'CU편의점 택배' },
  { value: '47', label: '우리한방택배' },
  { value: '48', label: 'ACI Express' },
  { value: '49', label: 'ACE Express' },
  { value: '50', label: 'GPS LOGIX' },
  { value: '51', label: '성원글로벌' },
  { value: '52', label: '세방' },
  { value: '53', label: '농협택배' },
  { value: '54', label: '홈픽택배' },
  { value: '55', label: 'Euro Parcel' },
  { value: '56', label: 'KGB 택배' },
  { value: '57', label: 'Cway Express' },
  { value: '58', label: '하이택배' },
  { value: '59', label: '지오로지스' },
  { value: '99', label: '현대택배 해외특송' },
  { value: '100', label: '나은물류' },
];

export const FALLBACK_IMAGE =
  'data:image/png;base64,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';

export const formSetValueOption = {
  shouldValidate: true,
  shouldTouch: true,
  shouldDirty: true,
};
